export const comments_3399190 = {"data":{"data":[],"links":{}}}